<template>
  <div class="contacts">
    <app-header/>
    <div class="container contacts-wrap">
      <div class="row justify-content-center">
        <div class="col-xl-10">
          <div class="google-maps-wrap">
            <div class="google-maps">
              <iframe src="https://yandex.ru/map-widget/v1/?um=constructor%3A3fdd750093d1caba63546d58e8c16051fb5d22158c9159bc05bd8691a0092d13&amp;source=constructor" width="100%" height="100%" frameborder="0"></iframe>
            </div>
          </div>

          <div class="row justify-content-center contacts-info">
            <div class="col-lg-8 order-lg-2 contacts-info__contact">
              <div class="row">
                <div class="col-sm-6">
                  <div class="contacts-info__title">Адрес</div>
                  <div class="contacts-info__data">Республика Казахстан,
                    <br>Индекс 150000 г. Петропавловск,
                    <br>Нурсултана Назарбаева 69А, офис 212
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="contacts-info__title">НОМЕР</div>
                  <div class="contacts-info__data">Офис в Петропавловске
                    <div class="contacts-info__data-wrap">
                      <a href="tel:+77152425573" class="contacts-info__link">8 (7152) 42-55-73</a>
                    </div>
                    <div class="contacts-info__data-wrap">
                      Генеральный директор
                      <br>Уразов Конуспай Шугаевич
                      <a
                        href="tel:+77015515341"
                        class="contacts-info__link"
                      >8 701 551 53 41</a>
                    </div>
                    <div class="contacts-info__data-wrap">
                      Электронная почта:
                      <a
                        href="mailto:sk_grant_petropavlovsk@mail.ru"
                        class="contacts-info__link"
                      >sk_grant_petropavlovsk@mail.ru</a>
                    </div>
                  </div>
                  <!-- end contacts-info__data -->
                </div>
              </div>
              <!-- end row -->
            </div>
            <!-- end col-lg-8 -->
            <div class="col-lg-4 order-lg-1 contacts-info__descr">
              <div class="row">
                <div class="col-lg-12">
                  <div class="image-container">
                    <img src="@/assets/logo.png">
                  </div>
                  <div class="contacts-info__descr-text">
                    Месторасположение карьера:
                    <br>Республика Казахстан,
                    СКО,
                    <br>Тайыншинский район,
                    <br>месторождение «Золоторунное»
                  </div>
                </div>
                <div class="col-lg-12">
                  <SidePanel :btnPositinLeft="true"/>
                </div>
              </div>
            </div>
          </div>
          <!-- end row contacts-info -->
        </div>
        <!-- end col-xl-10 -->
      </div>
      <!-- end row -->
    </div>
    <!-- end container -->
  </div>
  <!-- end contacts -->
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Button from "@/components/Button.vue";
import Modal from "@/components/Modal.vue";
import SidePanel from "@/components/SidePanel.vue";

export default {
  name: "Contacts",
  components: {
    "app-button": Button,
    "app-header": Header,
    SidePanel,
    Modal
  },
  metaInfo() {
    return {
      title: "Контакты",
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "Месторасположение карьера: Республика Казахстан, СКО, Тайыншинский район, месторождение «Золоторунное»"
        },
        {
          property: "og:title",
          content: "Контакты - TOO СК-Грант",
          vmid: "og:title"
        },
        {
          property: "og:description",
          content:
            "Месторасположение карьера: Республика Казахстан, СКО, Тайыншинский район, месторождение «Золоторунное»",
          vmid: "og:description"
        }
      ]
    };
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

